import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { parseSeverityLevel, SEVERITY_LEVEL_CONFIG } from '../../constants/severityLevel';

interface SeverityLevelBadgeProps {
  severityLevel: unknown;
  size?: number;
}

const SeverityLevelBadge: React.FC<SeverityLevelBadgeProps> = ({ severityLevel, size = 14 }) => {
  const level = parseSeverityLevel(severityLevel);
  if (!level) {
    return (
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          bgcolor: 'action.disabledBackground',
          verticalAlign: 'middle'
        }}
        aria-label="Sin severidad"
      />
    );
  }

  const config = SEVERITY_LEVEL_CONFIG[level];
  return (
    <Tooltip title={config.label}>
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          bgcolor: config.color,
          verticalAlign: 'middle'
        }}
        aria-label={config.ariaLabel}
      />
    </Tooltip>
  );
};

export default SeverityLevelBadge;
